import EditBar from './EditBar';

export default EditBar;
